import type { NextPage } from 'next';
import styled from '@emotion/styled';
import { useIsMobile } from '@hooks/responsive/useIsMobile';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

// components
import DefaultLayout from '@components/_templates/DefaultLayout';
import Title from '@components/_atoms/Title';
import Typography from '@components/_atoms/Typography';
import SearchContent from '@components/_templates/buyer/SearchContent';

// constants
import { MOBILE_MODE, TABLET_MODE } from '@constants/size';
import { TypoVariant } from '@constants/atoms';
import { gray } from '@styles/Colors';
import { useTranslation } from 'next-i18next';
import DefaultSEO from '@components/_organism/DefaultSEO';

const SearchWrapper = styled.div`
  width: 100%;
  max-width: 1160px;
  padding: 110px 40px;
  margin: 0 auto;

  @media ${TABLET_MODE} {
    max-width: 768px;
  }

  @media ${MOBILE_MODE} {
    max-width: 320px;
    padding: 104px 0;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 8px;
`;

const SubTitleWrapper = styled.div`
  margin-bottom: 40px;
  text-align: center;
`;

const Search: NextPage = () => {
  const { t } = useTranslation('search');
  const isMobile = useIsMobile();

  return (
    <>
      <DefaultSEO title={t('meta-title')} description={t('meta-description')} />
      <DefaultLayout>
        <SearchWrapper>
          <TitleWrapper>
            <Title content={t('title')} />
          </TitleWrapper>
          <SubTitleWrapper>
            <Typography variant={isMobile ? TypoVariant.B3 : TypoVariant.B4} color={gray.gray7}>
              {t('subTitle')}
            </Typography>
          </SubTitleWrapper>

          {/* CategoryContent */}
          <SearchContent />
          {/* CategoryContent end */}
        </SearchWrapper>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['search', 'common', 'component'])),
  },
});

export default Search;
